// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: "Poppins" !important;
}

.dashboard-layout {
  display: flex;
  height: 100vh;
}

.sidebar {
  width: 350px;
  background-color: #ffffff;
  padding-top: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
  position: relative;
}

.main-content {
  width: 100%;
  background-color: #fffbf4;
  margin-top: 0.6rem;
}

.accordion-button:focus {
  box-shadow: none !important;
}

.custom-scrollbar::-webkit-scrollbar {
  width: 4px;
  height: 4px;
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}

.custom-scrollbar::-webkit-scrollbar-track {
  background: transparent;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  visibility: hidden;
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}

.custom-scrollbar:hover::-webkit-scrollbar-thumb,
.custom-scrollbar:active::-webkit-scrollbar-thumb {
  visibility: visible;
  background: rgba(0, 0, 0, 0.6);
}

.accordion-button:not(.collapsed) {
  background-color: #7C13CA !important;
  color: #fff !important;
  box-shadow: none !important;
}

.accordion-button:not(.collapsed)::after {
  filter: brightness(0) invert(1);
}

/* Professional styling for code blocks inside Quill Editor */
.ql-editor pre.ql-syntax {
  background-color: #0f172a !important;
  color: #f8fafc !important;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace !important;
  padding: 1rem 1.5rem !important;
  border-radius: 0.5rem !important;
  font-size: 0.875rem !important;
  line-height: 1.7 !important;
  overflow-x: auto !important;
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
  border: 1px solid #1e293b !important;
}

/* Styling for inline code inside Quill Editor */
.ql-editor code {
  background-color: #f1f5f9 !important;
  color: #0f172a !important;
  padding: 0.2rem 0.4rem !important;
  border-radius: 0.25rem !important;
  font-size: 0.875rem !important;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace !important;
  border: 1px solid #e2e8f0 !important;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,wCAAgC;EAAhC,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,wCAAgC;EAAhC,gCAAgC;AAClC;;AAEA;;EAEE,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;AACjC;;AAEA,6DAA6D;AAC7D;EACE,oCAAoC;EACpC,yBAAyB;EACzB,0HAA0H;EAC1H,+BAA+B;EAC/B,gCAAgC;EAChC,8BAA8B;EAC9B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA,gDAAgD;AAChD;EACE,oCAAoC;EACpC,yBAAyB;EACzB,iCAAiC;EACjC,iCAAiC;EACjC,8BAA8B;EAC9B,0HAA0H;EAC1H,oCAAoC;AACtC","sourcesContent":["body {\n  font-family: \"Poppins\" !important;\n}\n\n.dashboard-layout {\n  display: flex;\n  height: 100vh;\n}\n\n.sidebar {\n  width: 350px;\n  background-color: #ffffff;\n  padding-top: 20px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);\n  position: relative;\n}\n\n.main-content {\n  width: 100%;\n  background-color: #fffbf4;\n  margin-top: 0.6rem;\n}\n\n.accordion-button:focus {\n  box-shadow: none !important;\n}\n\n.custom-scrollbar::-webkit-scrollbar {\n  width: 4px;\n  height: 4px;\n  transition: all 0.3s ease-in-out;\n}\n\n.custom-scrollbar::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.custom-scrollbar::-webkit-scrollbar-thumb {\n  background: rgba(0, 0, 0, 0.3);\n  border-radius: 10px;\n  visibility: hidden;\n  transition: all 0.3s ease-in-out;\n}\n\n.custom-scrollbar:hover::-webkit-scrollbar-thumb,\n.custom-scrollbar:active::-webkit-scrollbar-thumb {\n  visibility: visible;\n  background: rgba(0, 0, 0, 0.6);\n}\n\n.accordion-button:not(.collapsed) {\n  background-color: #7C13CA !important;\n  color: #fff !important;\n  box-shadow: none !important;\n}\n\n.accordion-button:not(.collapsed)::after {\n  filter: brightness(0) invert(1);\n}\n\n/* Professional styling for code blocks inside Quill Editor */\n.ql-editor pre.ql-syntax {\n  background-color: #0f172a !important;\n  color: #f8fafc !important;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !important;\n  padding: 1rem 1.5rem !important;\n  border-radius: 0.5rem !important;\n  font-size: 0.875rem !important;\n  line-height: 1.7 !important;\n  overflow-x: auto !important;\n  margin-top: 1rem !important;\n  margin-bottom: 1rem !important;\n  border: 1px solid #1e293b !important;\n}\n\n/* Styling for inline code inside Quill Editor */\n.ql-editor code {\n  background-color: #f1f5f9 !important;\n  color: #0f172a !important;\n  padding: 0.2rem 0.4rem !important;\n  border-radius: 0.25rem !important;\n  font-size: 0.875rem !important;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !important;\n  border: 1px solid #e2e8f0 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
